<template>
	<div>
		<div>
			<div class="p-6">
				<div style="background: #FFFFFF; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3); border-radius: 5px;padding: 20px;">
					<div class="mb-5">
						<h4 class="uppercase font-bold block text-xl w-full">TÌM CÁC UNC ĐÃ UPLOAD</h4>
					</div>

					<div class="mb-5">
						<span class="text-warning text-sm break-normal" style="display: block; text-">(*) Tìm và chọn 1 UNC theo các điều kiện dưới đây để xóa</span>
					</div>
					<div class="mb-5">
						<div class="mb-5">
							<label for class="text-base vs-input--label"> Nhà cung cấp: </label>
							<v-select
								:clearable="false"
								class="border-none w-full"
								:placeholder="`Chọn nhà cung cấp`"
								v-model="supplier"
								name="supplier"
								:options="$store.state.moduleProduct.suppliers"
								:reduce="(p) => p.id"
								label="name"
								:data-vv-as="'Nhà cung cấp'"
							/>
						</div>
						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Số hóa đơn
							</label>
							<cbs-input type="text" inputmode="text" v-model="payno_text" class="w-full" name="payno_text" :data-vv-as="'Số hóa đơn'" :placeholder="`${$t('Input')} Số hóa đơn`" />
						</div>

						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Từ ngày:
							</label>
							<CbsDatePicker value-format="yyyy-MM-dd HH:mm" name="from_date" :data-vv-as="'Thời gian'" class="w-full" v-model="from_date" type="datetime" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
						</div>

						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Tới ngày:
							</label>
							<CbsDatePicker value-format="yyyy-MM-dd HH:mm" name="to_date" :data-vv-as="'Thời gian'" class="w-full" v-model="to_date" type="datetime" placeholder="Chọn thời gian" :picker-options="pickerOptions" />
						</div>

						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Tên file UNC
							</label>
							<cbs-input type="text" inputmode="text" v-model="unc_text" class="w-full" name="unc_text" :data-vv-as="'Số hóa đơn'" :placeholder="`${$t('Input')} Số hóa đơn`" />
						</div>

						<div class="flex justify-end mb-5" slot="footer" vs-justify="end">
							<vs-button class="vs-component vs-button font-bold" @click.stop="applySeeking()">Tìm</vs-button>
						</div>

						<vs-row class="mb-2" :key="indextr" v-for="(itemPayment, indextr) in uncHoaDonMap">
							<vs-col vs-w="7" style="display: flex; vertical-align: middle;">
								<vs-radio v-on:change="changeItem(itemPayment)" :disabled="!isEditablePayno" :name="'payment_history_'+indextr" v-model="payno_checked" color="primary" :id="'payment_history_'+indextr" :vs-value="itemPayment.info.id.toString()" />
								<label :for="'payment_history_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{itemPayment.info.file_name}}
								</label>
							</vs-col>
							<vs-col vs-w="3" style="display: flex; vertical-align: middle;">
								<label :for="'payment_history_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{$helper.momentFormat(itemPayment.info.created_at)}}
								</label>
							</vs-col>
							<vs-col vs-w="2" style="display: flex; vertical-align: middle;">
								<a :href="itemPayment.info.path" target="_blank">Xem file</a>
							</vs-col>
						</vs-row>
					</div>

					<div class="mb-5" v-if="payment_nos.length">
						<span class="text-info text-sm break-normal" style="display: block; text-">Các hóa đơn đính kèm với UNC đã chọn</span>
						<vs-row class="mb-2" :key="indextr" v-for="(itemPayment, indextr) in payment_nos">
							<vs-col vs-w="4" style="display: flex; vertical-align: middle;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{itemPayment.payment_no}}
								</label>
							</vs-col>
							<vs-col vs-w="4" style="display: flex; vertical-align: middle;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{$helper.momentFormat(itemPayment.payment_date)}}
								</label>
							</vs-col>
							<vs-col vs-w="4" style="display: flex; vertical-align: middle;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{$helper.numFormat(itemPayment.payment_value)}}
								</label>
							</vs-col>
						</vs-row>
					</div>

					<div class="mb-5" style="align-items: center; align-items: center;display: flex;flex-direction: row;width: 100%;" v-if="payno_checked">
						<div v-if="isEditablePayno" class="ml-0" @click="setPaymentInfo()" :style="{cursor: 'pointer', 'box-shadow': '0px 0px 4px rgba(0, 0, 0, 0.25)', padding: '14px 7px', width: '250px', 'border-radius': '5px', 'text-align': 'center', background: 'rgb(222, 0, 0)', color: '#FFFFFF', 'font-weight': 700, display: 'flex', 'flex-direction': 'row', 'align-items': 'center', 'justify-content': 'center'}" >
							Xóa UNC
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRefCustom from "@/components/cbs-upload-ref/CbsUploadRefCustom";
import ListUploadMode from "@/components/cbs-upload-ref/ListUploadMode";

export default {
	name: "AccountUncHistory",
	components: { vSelect, SelectAssigned, CbsUploadRefCustom, ListUploadMode },
	props: {
		// isPopupActive: {
		// 	type: Boolean,
		// 	required: true,
		// },
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			uncHoaDon: {},
			uncHoaDonMap: {},
			unc_text: '',
			from_date: '',
			to_date: '',
			pickerOptions: {},
			payno_checked: null,
			supplier: '',
			payno_text: '',
			totalPaynos: 0,
			shippingHackPayments: [],
			data2: {},
			payment_files: [],
			payment_nos: [],
			activeShipping: {},
			shippingActiveIndex: 0,
			data2: {},
			cus_name: null,
			supplier_name: null,
			status: 0,
			productName: null,
			timeKey: Date.now(),
			timeKey2: Date.now(),
			photos: [],
			files: [],
			value: {},
			product: null,
			quantity: null,
			price: null,
			address: null,
			note: null,
			accountant_note: null,

			id: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			id: 0,
			product_id: 0,
			isEditablePayno: true,
			listShippingsByPmid: [],
			listShippingsByPmidStr: '',
			sohoadonstr: ''
		};
	},
	watch: {
		payment_files(val) {
			// console.log('payment_files: ', val);
			let maps = {};
			for (let kk in this.payment_nos) {
				let itemTmp = this.payment_nos[kk];
				if (itemTmp) {
					maps[itemTmp.id] = itemTmp;
				}
			}
			if (Object.keys(maps).length) {
				let total = 0;
				for (let k in val) {
					let kk = val[k];
					if (kk && maps.hasOwnProperty(kk)) {
						total += parseInt(maps[kk].payment_value);
					}
				}				
				this.totalPaynos = total;
			}
		},
	},
	computed: {
		localAttachFile: {
			get() {
				console.log('localAttachFile this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				console.log('localAttachFile set.value: ' , val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				console.log('this.files: ', this.files);
				// this.setPaymentInfo();
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
	},
	methods: {
		changeItem(item) {
			console.log(item);
			// this.shippingHackPayments = item.uncs || [];
			this.payment_nos = item.hoadons;
		},
		applySeeking() {
			if (this.supplier == null) {
				this.$helper.notifyWarning({ context: this, options: {
					text: 'Hãy chọn NCC',
				}});
				return;
			}
			this.getPaymentNos();
		},
		uploadChungTu() {
			document.querySelector('#custom-upload-history .el-upload__input').click();
		},
		getValueByKey(order, key) {
			if (order.type == 1 && order.matching_buy) {
				return order.matching_buy[key] || '-';
			}
			if (order.type == 2 && order.matching) {
				return order.matching[key] || '-';
			}

			return '';
		},
		getDataMatching(key) {
			if (this.data2 && this.data2.matching && this.data2.matching.hasOwnProperty(key)) {
				return this.data2.matching[key];
			}
			return '';
		},
		async getPaymentNos() {
			// this.$vs.loading();
			try {
				let payload = {id: this.supplier ? this.supplier : 0, payno_text: this.payno_text, unc_text: this.unc_text, from_date: this.from_date, to_date: this.to_date, type: 'unc'};
				this.$store.dispatch("moduleProduct/getPaymentNos", payload).then(response => {
					console.log('getPaymentNos: ', response);
					// this.payment_nos = response;
					let uncHoaDonMap = {};
					for (let k in response) {
						let hoadon = response[k];
						for (let kk in hoadon.uncs) {
							let uncTmp = hoadon.uncs[kk];
							if (!uncHoaDonMap.hasOwnProperty(uncTmp.id)) {
								uncHoaDonMap[uncTmp.id] = {info: uncTmp, hoadons: []};
							}
							uncHoaDonMap[uncTmp.id].hoadons.push(hoadon);
						}
					}
					this.uncHoaDonMap = uncHoaDonMap;
					this.uncHoaDon = Object.keys(uncHoaDonMap);
					console.log('uncHoaDonMap: ', uncHoaDonMap);
					console.log('uncHoaDon: ', this.uncHoaDon);

					// let uncs = [];
					// for (let k in response) {
					// 	let p = response[k];
					// 	if (p) {
					// 		uncs = [...uncs, ...(p.uncs || [])];
					// 	}
					// }
					// let finalUncs = uncs.reverse();
					// this.shippingHackPayments = finalUncs;
					// if (this.files.length < 1) {
					// 	this.files = finalUncs;
					// }
					// console.log('finalUncs: ', finalUncs);
					this.$vs.loading.close();
				});
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		getProductName() {
			if (!this.product_id) {
				return '';
			}
			let pName = '';
			for (let k in this.$store.state.moduleProduct.products) {
				let p = this.$store.state.moduleProduct.products[k];
				if (p && p.id == this.product_id) {
					pName = p.name;
					return pName;
				}
			}
			return pName;
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.address = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						type: this.data.type,
						productId: this.product,
						quantity: this.quantity,
						price: this.price,
						address: this.address,
						photos: this.files.map(item => item.id),
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.id) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đặt lệnh thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/createOrder", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async setPaymentInfo() {
			let unc = this.uncHoaDonMap[parseInt(this.payno_checked)];
			let files = null;
			if (unc) {
				files = unc.hoadons.map(f => {
					return f.id;
				});
			}
			if (!files) {
				return;
			}
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: this.$t("Actions.Confirm"),
				text: 'Xác nhận xóa UNC này',
				// accept: () => this.deleteCustomer(customer._id),
				accept: async () => {
					try {
						// this.$vs.loading();
						let payload = {id: this.supplier ? this.supplier : 0, checked_ids: files, type: 'remove'};
						console.log(payload);
						await this.$store.dispatch("moduleProduct/setPaymentInfo", payload);
						this.$helper.notifySuccess({ context: this, options: {
							text: 'Đã xóa',
						}, });
						this.applySeeking();
						this.payment_nos = [];
					} catch (error) {
						console.log('error: ', error);
						this.$helper.notifyWarning({ context: this, options: {
							text: error,
						}, });
					} finally {
						this.$vs.loading.close();
					}
				},
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
	created() {
		// console.log('created: ', Date.now());
		// this.getOrder(true);
	}
};
</script>

<style>
#custom-upload-history .el-upload--picture-card {
	display: none;
}
</style>